import AddAccessRight from '../AccessRight/AddAccessRight';
import { SERVER_URI, TEST_URI } from '../Constant/server';
import { apiGet, apiPost, apiPost1 } from '../utils/axios';

const UPLOAD_NEW_PHOTO = `${SERVER_URI}/upload-promotion-banner`;
const GET_BANNER = `${SERVER_URI}/get-promotion-banner`;

export default {
  Upload_Photo: async function (payload) {
    // console.log('ff',payload);
    return apiPost1(UPLOAD_NEW_PHOTO, payload);
  },
  UploadBannerData: async function () {
    return apiGet(GET_BANNER);
  }
};
